import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addHandServer from "./components/addHandServer.vue";
import { getOpenServerManualLog, delOpenServerManualLog } from "@/api/gmtool/packageCode";
import richTextDetails from "./components/richTextDetails.vue";
import { gmTool } from "@/mixins/index";
import { times } from "lodash";
export default {
  name: "automaticServer",
  mixins: [gmTool],
  components: {
    addHandServer: addHandServer,
    richTextDetails: richTextDetails
  },
  data: function data() {
    return {
      paramsData: {
        status: 1
      },
      tableData: [],
      serverLaunch: [{
        label: this.$t('yes'),
        value: 1
      }, {
        label: this.$t('no'),
        value: 2
      }, {
        label: this.$t('schedule'),
        value: 0
      }],
      isMobile: false
    };
  },
  activated: function activated() {
    this.getList();
  },
  created: function created() {
    this.checkMobile();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize: function handleResize() {
      this.checkMobile();
    },
    getList: function getList(e) {
      var _this = this;

      this.paramsData.page = e;
      this.reqLoading = true;
      getOpenServerManualLog(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        game_id: this.rawData.game_id
      })).then(function (res) {
        if (res.code == 200) {
          _this.tableData = res.data.data;
          _this.total = res.data.total;
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    // 删除配置
    handleDelete: function handleDelete(id) {
      var _this2 = this;

      this.$confirm(this.$t('confirmDelete'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                delOpenServerManualLog({
                  id: id
                }).then(function (res) {
                  if (res.code == 200) {
                    _this2.getList(_this2.paramsData.page);

                    _this2.$message({
                      type: "success",
                      message: _this2.$t('deleteSuccess')
                    });
                  }
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};